import { Suspense, lazy, type ComponentProps } from 'react'

/**
 * The "+ → Humans" tab is the only thing that pulls the QR libraries — its
 * FriendScanner reaches jsqr (~250 KB) through the camera decoder, and its "show my
 * code" reaches qrcode-generator (~50 KB). Adding a friend is a rare, deliberate act,
 * so loading the whole tab through React.lazy keeps both out of the initial chunk
 * (M9); they arrive when the tab is opened.
 */
const AddHumansImpl = lazy(() =>
  import('./AddHumans').then((m) => ({ default: m.AddHumans })),
)

type Props = ComponentProps<(typeof import('./AddHumans'))['AddHumans']>

export function AddHumansLazy(props: Props) {
  return (
    <Suspense fallback={null}>
      <AddHumansImpl {...props} />
    </Suspense>
  )
}
